import { logException } from '@atlaskit/editor-common/monitoring/error';

export const openTemplateGallerySafely = (openTemplateGallery: () => void): void => {
	try {
		openTemplateGallery();
	} catch (error) {
		logException(error as Error, {
			location: 'editor-plugin-snippets/openTemplateGallery',
		});
	}
};
